import React, { useEffect, useMemo, useState } from "react";
import { baseUrl } from "../../../../../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../network/api";
import CategoryTable from "./categoryTable/categoryTable";
import "./businessCategory.css";
import CategoryForm from "./categoryForm/categoryForm";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Alert, Snackbar } from "@mui/material";
import { Spinner } from "react-bootstrap";

const BusinessCategory = ({ franchiseId }) => {
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleAddForm = () => {
    setSelectedCategory(null);
    setIsEdit(false);
    setOpenForm(true);
  };

  const handleEditForm = (category = null) => {
    setSelectedCategory(category);
    setOpenForm(true);
    setIsEdit(true);
  };

  const handleCloseForm = () => {
    setIsEdit(false);
    setOpenForm(false);
    setSelectedCategory(null);
  };

  const handleDeleteClose = () => {
    setShowDeletePopup(false);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchCategory = () => {
    setLoading(true);
    axios
      .get(
        baseUrl + `superadmin/category-list-by-business-id/${franchiseId}`,
        config
      )
      .then((response) => {
        setCategoryList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSubmit = (updatedData) => {
    setLoading(true);
    const form = new FormData();
    form.append("category_name", updatedData.category_name);
    form.append("is_home_listed", updatedData.is_home_listed);
    form.append("business", franchiseId);

    if (!isEdit && (!updatedData.icon || !(updatedData.icon instanceof File))) {
      setSnackbar({
        open: true,
        message: "Please select an image before submitting.",
        severity: "error",
      });
      setLoading(false);
      return;
    }
    if (updatedData.icon && updatedData.icon instanceof File) {
      form.append("icon", updatedData.icon);
    }

    if (isEdit) {
      editData(form);
    } else {
      submitData(form);
    }
  };

  const submitData = (updatedData) => {
    axios
      .post(`${baseUrl}app/category/create/`, updatedData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(true);
        fetchCategory();
        setSnackbar({
          open: true,
          message: response.data.message || "New category added successfully",
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding data:", error);
      });
  };

  const editData = (updatedData) => {
    const id = selectedCategory.id;

    axios
      .put(`${baseUrl}app/category/edit-or-delete/${id}/`, updatedData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        fetchCategory();
        setSnackbar({
          open: true,
          message: response.data.message || "Changes saved successfully",
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Something went wrong. Please try again!",
          severity: "success",
        });
        console.error("Error adding data:", error);
      });
  };

  const handleDeleteClick = (service) => {
    setCategoryToDelete(service.id);
    setShowDeletePopup(true);
  };

  const confirmDelete = () => {
    if (categoryToDelete) {
      deleteService(categoryToDelete);
      setCategoryToDelete(null);
      setShowDeletePopup(false);
    }
  };

  const deleteService = (serviceId) => {
    setLoading(true);

    axios
      .delete(`${baseUrl}app/category/edit-or-delete/${serviceId}/`, config)
      .then((response) => {
        fetchCategory();
        setSnackbar({
          open: true,
          message: response.data.message || "Category deleted successfully",
          severity: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting service:", error);
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Something went wrong. Please try again!",
          severity: "error",
        });
      });
  };
  return (
    <div className="mt-3 category-container">
       {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
       ):(
        <>
      <button className="btn-add-category" onClick={handleAddForm}>
        + Add Category
      </button>
      <CategoryTable
        categoryList={categoryList}
        onEdit={handleEditForm}
        onDelete={handleDeleteClick}
      />
      <CategoryForm
        open={openForm}
        onClose={handleCloseForm}
        onSubmit={handleSubmit}
        category={isEdit ? selectedCategory : null}
        franchiseId={franchiseId}
      />

      <Dialog
        open={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Do you really want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ textTransform: "none" }}
            onClick={confirmDelete}
          >
            Delete
          </Button>
          <Button
            size="small"
            style={{
              textTransform: "none",
              color: "grey",
              outline: "1px solid grey",
            }}
            onClick={handleDeleteClose}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      </>
       )}
    </div>
  );
};

export default BusinessCategory;
